module.exports = __webpack_public_path__ + "img/credit_card.427dfc8a.svg";